import clsx from 'clsx';
import React, { type ReactElement } from 'react';

import IconQuote from '@components/Images/Rebranding/IconQuote';
import LazyImgixImage from '@components/LazyImgixImage';

import type { QuotationProps } from './interfaces';

const Quotation = ({
  photoUrl,
  isPro = true,
  quote,
  source,
  title,
}: QuotationProps): ReactElement => {
  const hasPhoto = !!photoUrl;

  return (
    <article
      className={clsx(
        'm-auto flex w-full flex-col gap-16 lg:flex-row lg:items-start',
        '[.is-carouseled_&]:min-w-[65svw] [.is-carouseled_&]:!border-0 [.is-carouseled_&]:!border-b-[3px] [.is-carouseled_&]:!border-solid [.is-carouseled_&]:px-0 [.is-carouseled_&]:!pb-20 [.is-carouseled_&]:sm:min-w-[calc(50svw-72px)] [.is-carouseled_&]:nav:min-w-0',
        {
          '[.is-carouseled_&]:border-primary-magenta': !isPro,
          '[.is-carouseled_&]:border-pro-gold': isPro,
          'h-full': hasPhoto,
        }
      )}
    >
      <IconQuote
        className={clsx('w-48 shrink-0', {
          'text-pro-gold': isPro,
          'text-primary-magenta': !isPro,
        })}
      />
      <div
        className={clsx({
          'flex h-full flex-col justify-between': hasPhoto,
        })}
      >
        <blockquote className="m-0 font-suisse-neue text-body-md font-normal text-grayscale-charcoal md:text-body-lg">
          {quote}”
        </blockquote>
        <div
          className={clsx({
            'md:flex-row-nowrap md:mt-24 md:flex md:items-center md:gap-24': hasPhoto,
          })}
        >
          {hasPhoto && (
            <LazyImgixImage
              src={photoUrl}
              alt={source || title}
              className="h-[90px] w-[90px] rounded-full object-cover"
              wrapperClassName="mt-24 mb-10 md:my-0"
            />
          )}
          {(source || title) && (
            <cite
              className={clsx(
                'm-0 mt-8 block font-suisse-screen not-italic text-grayscale-charcoal',
                {
                  'text-byline-lg md:mt-0': hasPhoto,
                  'text-byline-sm md:mt-16 md:text-byline-md': !hasPhoto,
                }
              )}
            >
              {source && (
                <span className="font-bold">
                  {photoUrl ? '' : '—'} {source}
                </span>
              )}
              {hasPhoto && title ? (
                <span className="block text-byline-md font-normal">{title}</span>
              ) : (
                title && `, ${title}`
              )}
            </cite>
          )}
        </div>
      </div>
    </article>
  );
};

export default Quotation;
